let BrandName = /*#__PURE__*/function (BrandName) {
  BrandName["BIGCOMMERCE"] = "bigcommerce";
  BrandName["CORREOS"] = "correos";
  BrandName["DPD"] = "dpd";
  BrandName["EBAY"] = "ebay";
  BrandName["EBAY_IT"] = "ebay_it";
  BrandName["FALLBACK"] = "fallback";
  BrandName["PACKLINK_CONS"] = "packlink_cons";
  BrandName["PACKLINK_PRO"] = "packlink_pro";
  BrandName["PAYPAL"] = "paypal";
  BrandName["PAYPAL_SHIPCENTER"] = "paypal_shipcenter";
  BrandName["SHIPENGINE_DASHBOARD"] = "shipengine_dashboard";
  BrandName["SHIPSTATION"] = "shipstation";
  return BrandName;
}({});

export { BrandName };
//# sourceMappingURL=BrandName.js.map
